<template>
	<div class="input-container" :class="[{'hasError': canShowError}, size]">
		<label :for="inputName+'_input'" class="input-label" v-if="label">
			{{ name }}

			<button v-if="tooltip" class="tooltip-el" v-tooltip="tooltip">?</button>

		</label>
		<div class="relative rounded-md shadow-sm input-div h-full" :class="{'mt-1': (label) ? true : false}">
			<div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" v-if="icon">
				<svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" v-if="isSVG(icon)">
					<!-- Mail icon -->
					<path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" v-if="icon == 'mail'"/>
					<path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" v-if="icon == 'mail'"/>

					<!-- Wallet icon -->
					<path d="M0 4c0-1.1.9-2 2-2h15a1 1 0 0 1 1 1v1H2v1h17a1 1 0 0 1 1 1v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm16.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" v-if="icon == 'wallet'"/>

					<!-- Location icon -->
					<path d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13zm0-11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" v-if="icon == 'location'" />

					<!-- Password icon -->
					<path d="M4 8V6a6 6 0 1 1 12 0v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h1zm5 6.73V17h2v-2.27a2 2 0 1 0-2 0zM7 6v2h6V6a3 3 0 0 0-6 0z" v-if="icon == 'password'"/>
				</svg>
				<div v-else>
					<i class="fas fa-user text-gray-400" v-if="icon == 'person'"></i>
					<i class="fas fa-phone text-gray-400" v-if="icon == 'phone'"></i>
					<i class="fas fa-birthday-cake text-gray-400" v-if="icon == 'dob'"></i>
				</div>
			</div>

			<div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" v-if="addon">
				<span class="text-gray-500 sm:text-sm sm:leading-5">
					{{ addon }}
				</span>
			</div>
			<datepicker input-class="form-input block w-full sm:text-sm sm:leading-5 h-full" v-model="inputVal" v-if="type =='datepicker'" @closed="updated" :placeholder="placeholder" :use-utc="true" :open-date="datepicker_state.date" initial-view="year" :disabled-dates="datepicker_state.disabledDates"></datepicker>
			<input :name="id" :type="inputType" v-model="inputVal" class="form-input block w-full  h-full" :class="{'indent-8': icon || addon}" :placeholder="placeholder" @keyup="updated" @keyup.enter='$emit("event:enter")' :autocomplete="(autoComplete) ? 'on' : 'off'" v-else/>


			<div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="canShowError">
				<svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
					<path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
				</svg>
			</div>
		</div>
		<Transition name="fade">
			<p class="text-xs text-red-600 fade h-1" :class="{'opacity-100': canShowError, 'opacity-0': !canShowError}" v-if="showErrorText">
				<span>
					{{ errors }}
				</span>
			</p>
		</Transition>
	</div>
</template>

<script>
	export default {
		name: 'form.input',
		props: {
			name: {
				type: String
			},
			inputType: {
				type: String,
				default: 'text'
			},
			placeholder: {
				type: String
			},
			icon: {
				type: String
			},
			showError: {
				type: Boolean,
				default: false
			},
			showErrorText: {
				type: Boolean,
				default: true
			},
			minVal: {
				type: Number,
			},
			maxVal: {
				type: Number,
			},
			type: {
				type: String,
			},
			label: {
				type: Boolean,
				default: true,
			},
			inputId: {
				type: String
			},
			addon: {
				type: String,
			},
			size: {
				type: String
			},
			val: {
				type: String|Date,
			},
			autoComplete: {
				type: Boolean,
				default: true,
			},
			tooltip: {

			},
            datepicker_state: {

            },
		},
		data() {
			return {
				inputVal: null,
			}
		},
		computed: {
			inputName() {
				var name = this.name;

				if(this.name) {
					// replace spaces
					name = name.replace(/ /g, "_");

					// lowercase
					name = name.toLowerCase();
				}

				return name;
			},
			id() {
				if(this.inputId) {
					return this.inputId;
				}

				return this.inputName;
			},
			errors() {
				// must be a number if min/max value provided
				if(this.minVal || this.maxVal) {
					if(!Number.isInteger(+this.inputVal)) {
						return this.name + ' must be a number';
					}
				}

				// minimum value validation
				if(this.minVal && this.maxVal) {
					if(this.inputVal < this.minVal || this.inputVal > this.maxVal) {
						return this.name + ' must be between ' + this.minVal + ' and ' + this.maxVal;
					}
				}

				// minimum value validation
				if(this.minVal) {
					if(this.inputVal < this.minVal) {
						return this.name + ' cannot be lower than ' + this.minVal;
					}
				}

				// maximum value validation
				if(this.maxVal) {
					if(this.inputVal > this.maxVal) {
						return this.name + ' cannot be greater than ' + this.maxVal;
					}
				}

				// postcode validation
				if(this.type == 'postcode') {
					let regEx = /[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][A-Za-z]{2}/g;

					if(!regEx.test(this.inputVal)) {
						return 'Must be a valid postcode';
					}
				}

				return '';
			},
			canShowError() {
				if(this.showError && this.errors) {
					return true;
				}

				return false;
			}
		},
		watch: {
			val: function (newVal, oldVal) {
				this.inputVal = this.val;
			}
		},
		mounted() {
			this.inputVal = this.val;

			// send data when first mounted so parent has error messages if user just tries to submit form
			this.updated();
		},
		methods: {
			isSVG(icon) {
				const svg = ["mail", "wallet", "location", "password"];

				if(svg.includes(icon)) {
					return true;
				}

				return false;
			},
			updated() {
				// send back object with input name/value
				var updateVals 		  = {};
				updateVals[this.id] = {
					value: this.inputVal,
					errors: this.errors
				}

				this.$emit('updated', updateVals);
			}
		}
	}
</script>
